import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { UserService } from '../../service/user.service';
// @ts-ignore
import { InAppPurchase } from '@ionic-native/in-app-purchase/ngx';
import { Storage } from '@ionic/storage';
import { HttpClient } from '@angular/common/http';
import { MenuPage } from '../menu/menu';
import { AlbumService } from '../../service/album.service';

/**
 * Generated class for the RegisterPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-register',
  templateUrl: 'register.html',
})
export class RegisterPage {

  email:string = "";
  password:string = "";
  firstname:string;
  lastname:string;
  iap: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public us: UserService,
    public albumService: AlbumService,
    private storage: Storage,
    public http: HttpClient,
    public toastController: ToastController
    ) {
  }

  ngOnInit()
  {
    // @ts-ignore
    this.iap = inAppPurchase;
  }

  buy(){

    if (this.email != "" && this.password != "" && this.firstname != "" && this.lastname != "")
  {
// "com.linusanderas.musicbarnskivor.barnskivor.month"
    this.iap.getProducts( ["barnskivor.year" ] ).then( products => {

      console.log(products);

      this.iap.subscribe( "barnskivor.year" ).then( result => {

        
        this.registerAndLogin();


      }).catch( err => {

        console.log(err)

      });

    }).catch( err => {
      console.log(err)
    })

  }

  else
  {
    const toast =  this.toastController.create({
      message: 'Du måste fylla i hela formuläret för att kunna slutföra köpet.',
      duration: 2000,
      position: 'middle'
    });
    toast.present();
  }

}

public registerAndLogin()
{

  console.log("register");

  this.us.setUser(this.email, this.firstname, this.lastname, this.password, 1).subscribe(data => {

    this.http.get('https://minmusik.se/api/login?email=' + this.email + "&password=" + this.password ).subscribe(data => {

  if (data != null)
  {

    this.storage.set("login", this.email + "#" + this.password);

    this.us.user.id = data["id"];
    this.us.user.email = data["email"];
    this.us.user.firstname = data["firstname"];
    this.us.user.lastname = data["lastname"];

    this.albumService.load();
    this.us.loadPlaylists();

    this.storage.get("quality").then((data:string) => {

      if (data)
      {
        this.us.user.quality = data;
      }
      else
      {
        this.us.user.quality = "high";
        this.storage.set("quality", "high");
      }

    })

    this.navCtrl.setRoot(MenuPage);
  }

  });

});
}


 
}



// WEBPACK FOOTER //
// ./src/pages/register/register.ts